var getWrapperClassName = (function (_ref) {
  var className = _ref.className,
      wrapperClassName = _ref.wrapperClassName;

  if (wrapperClassName) {
    return wrapperClassName;
  }

  return className ? className + "-wrapper" : undefined;
});

export default getWrapperClassName;
